import "./../../bindings/bao-number-box";
import GenericListTab from "./../../factories/generic-list-tab";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class ShiftPlanModelDetailTab extends GenericListTab {
    Bao = Bao;

    Models: KnockoutObservableArray<any>;

    DialogWidth = 500;
    CustomFilter() {
        return null;
    }

    CompleteCheck(): JQueryPromise<boolean> | boolean {
        var def = $.Deferred<boolean>();
        var result = true;

        //Get all days
        var daysArray = this.Models().map(a => a.SerialDay);

        //No data to check
        if (daysArray.length === 0) {
            def.resolve(result);
            return def.promise();
        }

        //Sort for duplicate days and day 0 exists checks
        daysArray.sort((a, b) => a - b);

        //Day 0 exists check
        if (daysArray[0] !== 0) {
            result = false;
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgShiftPlanModelDetailDay0NotExists"), "info");
            def.resolve(result);
            return def.promise();
        }

        //Find duplicates
        var hasDuplicates = false;
        var duplicatedEntry = 0;
        for (var i = 1; i < daysArray.length; i++) {
            if (daysArray[i] === daysArray[i - 1]) {
                hasDuplicates = true;
                duplicatedEntry = daysArray[i];
                break;
            }
        }
        //No duplicate days check
        if (hasDuplicates) {
            result = false;
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgShiftPlanModelDetailDayAssignedTwice").then((result) => result.replace("{0}", duplicatedEntry.toString())), "info");
            def.resolve(result);
            return def.promise();
        }

        //Consecutive days check
        if (daysArray[0] + daysArray.length != daysArray[daysArray.length - 1] + 1) {
            result = false;
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgShiftPlanModelDetailDaysNotConsecutive"), "info");
            def.resolve(result);
            return def.promise();
        }

        def.resolve(result);
        return def.promise();
    }


    ItemCompleteCheck(item): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        var result = true;
        if (item.SerialDay() == null) {
            result = false;
        }
        if (item.ShiftTypeId() == null) {
            result = false;
        }
        if (!result) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        def.resolve(result);
        return def.promise();
    }


}
export default ShiftPlanModelDetailTab;